const thumbnailPrefix = 'thumbnail';
export const dataHooks = {
    thumbnailSelectedIcon: `${thumbnailPrefix}-selected-icon`,
    thumbnailDescription: `${thumbnailPrefix}-description`,
    thumbnailTitle: `${thumbnailPrefix}-title`,
    thumbnailImage: `${thumbnailPrefix}-image`,
    thumbnailBackgroundImage: `${thumbnailPrefix}-background-image`,
    thumbnailBottomTitle: `${thumbnailPrefix}-bottom-title`,
    thumbnailWrapper: `${thumbnailPrefix}-wrapper`,
};
//# sourceMappingURL=constants.js.map